import { render, staticRenderFns } from "./GreetingsMessage.vue?vue&type=template&id=2d13844c&scoped=true"
import script from "./GreetingsMessage.vue?vue&type=script&lang=js"
export * from "./GreetingsMessage.vue?vue&type=script&lang=js"
import style0 from "./GreetingsMessage.vue?vue&type=style&index=0&id=2d13844c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13844c",
  null
  
)

export default component.exports